import { Schema } from './Collection.schema';

// adding collection via section allows control of order of grid on the page
export function Collection() {
  return null;
}

Collection.displayName = 'Collection';
Collection.Schema = Schema;
